import styled from "styled-components";
import {Navigate, Route, Routes} from "react-router-dom";
import DemoPointEnv from "./demoPointEnv/DemoPointEnv";
import Sidebar from "./navigator/Sidebar";
import CreateEnv from "./demoPointEnv/createEnv/CreateEnv";
import IntReports from "./IntReports/IntReports";
import {cpx, userDetails} from "../../utils/const/query-key";
import apiService from "../../api/apiService";
import {useQuery} from "react-query";
import ThreatGuard from "./threatGuard/ThreatGuard";
import {ModalProvider} from "./demoPointEnv/envResultsTable/ModalContext";
import PrivateRoute from "./navigator/PrivateRoute";
import Loading from "./Loading";

const Wrapper = styled.div`
  font-size: 1.4rem;
  color: var(--color-text-general);
  position: relative;

  grid-area: content;

  display: grid;
  grid-template-columns: 1fr 114px 1066px 1fr;
  grid-template-rows: auto;
  grid-template-areas: "........      sidenav     page-area      ........";

  * {
    box-sizing: border-box;
  }
`;

const PageArea = styled.div`
  grid-area: page-area;
  background-color: var(--color-workspace-bg-page-area);
  padding: 2rem;
`;

const App = () => {
    const {data: userData,isLoading} = useQuery(userDetails, () => apiService.getUser());
    const {data: isCpx} = useQuery(cpx, () => apiService.getIsCpx());
    if (isLoading) {
        return <Loading/>;
    }
    return (
        <ModalProvider>
            <Wrapper>
                <Sidebar/>
                <PageArea>
                    <Routes>
                        <Route path="/demo-point" exact element={<DemoPointEnv/>}/>
                        {(userData?.isCpSales || userData?.isUserCenterPartner) && (
                            <>
                                <Route path="/intelligence-reports" element={<IntReports />} />
                                {/*<Route path="/threatguard" element={<ThreatGuard />} />*/}
                                <Route path="/demo-point/createEnv" element={<CreateEnv createCpxEnv={false} />} />
                            </>
                        )}
                        <Route path="/demo-point/createEnvCPX" element={<CreateEnv createCpxEnv={true}/>}/>
                        <Route path="/admin/*" element={<PrivateRoute/>}/>
                        <Route path="*" element={<Navigate replace to={"/demo-point"}/>}/>
                    </Routes>
                </PageArea>
            </Wrapper>
        </ModalProvider>
    );
};

export default App;
